<template>
    <div class="hello">
        <h1>About Page</h1>
        <h3>Đây là trang giới thiệu</h3>
      <div>
        <select class="seleclist" @change="change()">
          <option>Choose Color</option>
          <option value="news">Tin tức</option>
          <option value="story">Truyện hay</option>
          <option value="love">Cửa sổ tình yêu</option>
          <option value="health">Sức khỏe</option>
        </select>
      </div>

      <div class="tab-content">
        <div id="news" class="news tab-pane"><br>
          Tin tức
        </div>
        <div id="story" class="story tab-pane"><br>
          Truyện hay
        </div>
        <div id="love" class="love tab-pane"><br>
          Tình yêu
        </div>
        <div id="health" class="health tab-pane"><br>
          Sức khỏe
        </div>
      </div>

      <autocomplete
        :place-holder-text="placeHolderInputText"
        :result-items="autoCompleteResult"
        :on-change="onKeyUpAutoCompleteEvent"
        :on-selected="onSelectedAutoCompleteEvent"
        :on-arrow-down="onArrowDown"
        :on-arrow-up="onArrowUp"
        :on-enter="onEnter"
        :auto-complete-progress="autoCompleteProgress"
        :item-text="autoCompleteText"
        :item-id="autoCompleteFieldId"
        :value-arrow-counter="arrowCounter"
        :value-input="valueSelected">
      </autocomplete>
    </div>
</template>

<script>
  import Autocomplete from './Autocomplete'
  export default {
    name: 'About',
    components: {
      Autocomplete
    },
    data () {
      return {
        msg: 'Welcome to Your Vue.js App abc xyz vvvvvv',
        placeHolderInputText: 'Nhập tên quốc gia',
        autoCompleteResult: [],
        autoCompleteProgress: false,
        autoCompleteText: "name",
        autoCompleteFieldId: "alpha3Code",
        valueSelected: null,
        arrowCounter: 0,
      }
    },
    mounted () {
      $(".news").show();
    },
    methods: {
      change(){
        var select = $(".seleclist");
        var s = select[0];
        $(s).find("option:selected").each(function(){
          var optionValue = $(this).attr("value");
          if(optionValue){
            $(".tab-pane").not("." + optionValue).hide();
            $("." + optionValue).show();
          } else{
            $(".tab-pane").hide();
          }
        });
      },

      onSelectedAutoCompleteEvent (id, text) {
        this.autoCompleteProgress = false;
        this.autoCompleteResult = [];
        this.valueSelected = text;
        //alert("Bạn đã chọn " + id + ": " + text);
      },

      onKeyUpAutoCompleteEvent (keywordEntered) {
        //reset
        this.autoCompleteResult = [];
        this.autoCompleteProgress = false;
        if (keywordEntered.length > 2) {
          this.autoCompleteProgress = true;
          axios.get("https://restcountries.eu/rest/v2/name/" + keywordEntered)
            .then(response => {
              //because the name can contains partial name, we only include the country that contains the keyword text
              var newData = [];
              response.data.forEach(function (item, index) {
                if (item.name.toLowerCase().indexOf(keywordEntered.toLowerCase()) >= 0) {
                  newData.push(item);
                }
              });
              this.autoCompleteResult = newData;
              this.autoCompleteProgress = false;
            })
            .catch(e => {
              this.autoCompleteProgress = false;
              this.autoCompleteResult = [];
            })
        } else {
          this.autoCompleteProgress = false;
          this.autoCompleteResult = [];
        }
      },
      onArrowDown() {
        if (this.arrowCounter < this.autoCompleteResult.length) {
          this.arrowCounter = this.arrowCounter + 1;

        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      },
      onEnter() {
        this.valueSelected = this.autoCompleteResult[this.arrowCounter].name;
        this.autoCompleteProgress = false;
        this.autoCompleteResult = [];
        this.arrowCounter = -1;
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tab-pane{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue